(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminDisplaySettingsController', AdminDisplaySettingsController);

    function AdminDisplaySettingsController(
        lodash,
        settingsCollection,
        settingsFields,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
        ) {
        const vm = this;
        vm.settingsCollection = settingsCollection;
        vm.settings = loadSettings(settingsCollection.settings);
        vm.fromJson = fromJson;
        vm.stringToArray = stringToArray;
        vm.valueIsEmpty = valueIsEmpty;
        vm.recurrenceRulesService = recurrenceRulesService;
        vm.settingsCollection.count = settingsFields.length;
        vm.meridianEnabled = modulesService.isEnabled('meridian');
        vm.auditsModuleEnabled = modulesService.isEnabled('audits_module');
        vm.contractsModuleEnabled = modulesService.isEnabled('contracts_module');

        if (module && !elbSettings.getSetting(module).value) {
            $state.go('dashboard.user.dashboard');
        }

        function loadSettings(settingsArray) {
            const settings = {};

            for (const i in settingsFields) {
                settings[settingsFields[i]] = angular.copy(lodash.find(settingsArray, { name: settingsFields[i] }));
            }

            return settings;
        }

        function fromJson(value) {
            return value ? angular.fromJson(value) : [];
        }

        function stringToArray(value) {
            return value.length > 0 ? value.split(',') : [];
        }

        function valueIsEmpty(value) {
            return lodash.isEmpty(value) && !lodash.isNumber(value);
        }
    }
})();

